import type React from 'react'

import { useAuth } from '@/hooks'

import { AppSidebarBrasil } from './app-sidebar-brasil'
import { AppSidebarChile } from './app-sidebar-chile'

export const AppSidebar = (props: React.ComponentProps<typeof AppSidebarBrasil>) => {
  const { user } = useAuth()
  const isBrasil = user?.localidade === 'pt-BR'

  if (isBrasil) {
    return <AppSidebarBrasil {...props} />
  }

  return <AppSidebarChile {...props} />
}
